<template>
  <v-card :loading="store.fetchingFlags.oficinas" :disabled="store.fetchingFlags.oficinas" flat>
    <v-alert
      v-if="store.errorMessages.oficinas"
      type="error"
      class="mb-4"
    >
      
      <template v-slot:text>
        {{ store.errorMessages.oficinas }}
        <v-btn
          text="Reintentar"
          variant="outlined"
          @click="retryFetchOficinas"
        >
        </v-btn>
      </template>
    </v-alert>

    <FormField
      v-model="store.formData.empresaRemitente"
      field-type="v-autocomplete"
      label="Oficina Remitente"
      :items="store.apiCache.oficinas"
      :rules="[rules.required]"
      class="mt-2"
    />
  </v-card>
</template>

<script setup>
import { onMounted } from 'vue'
import { useSolicitudMensajeriaStore } from '@/stores/solicitudMensajeria'
import FormField from './FormField.vue'

const store = useSolicitudMensajeriaStore()

const rules = {
  required: (value) => !!value || "Campo requerido"
}

const retryFetchOficinas = async () => {
  await store.fetchOficinas()
}

onMounted(async () => {
  await store.fetchOficinas()
})
</script> 